import React from 'react'
import { Button, Tooltip } from 'antd'
import { Search } from 'lucide-react'
import { GoBar } from './GoBar'
import { useFFEStore } from '../../store/ffeStore'

export const GoBarButton: React.FC = () => {
  const [showGoBar, setShowGoBar] = React.useState(false)
  const isPreviewing = useFFEStore((state) => state.isPreviewing)

  if(isPreviewing) return null
  return (
    <>
      <GoBar open={showGoBar} setOpen={setShowGoBar} />
      <Tooltip title="Search (Press '/' to open)">
        <Button
          icon={<Search className="h-4 w-4" />}
          onClick={() => setShowGoBar(true)}
        >
          <div className='hidden md:block'>Search document</div>
        </Button>
      </Tooltip>
    </>
  )
}
